import { render, staticRenderFns } from "./FacebookCampaignsTable.vue?vue&type=template&id=62225c5b&scoped=true&"
import script from "./FacebookCampaignsTable.vue?vue&type=script&lang=js&"
export * from "./FacebookCampaignsTable.vue?vue&type=script&lang=js&"
import style0 from "./FacebookCampaignsTable.vue?vue&type=style&index=0&id=62225c5b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62225c5b",
  null
  
)

export default component.exports